import { createSelector } from "reselect";

import { INotification } from "../Models/Notification";
import { IRootReducer } from "../Reducers/RootReducer";

export const notificationsFilterDatesSelector = createSelector(
    (state: IRootReducer) => {
        return {
            startDate: state.notificationsReducer.startDate,
            endDate: state.notificationsReducer.endDate
        };
    },
    ({startDate, endDate}): [Date, Date] => ([
        startDate,
        endDate
    ])
);

export const notificationsDrawerVisibleSelector = createSelector(
    (state: IRootReducer) => state.notificationsReducer.drawerVisible,
    (visible: boolean) => visible
);

export const loadingNotificationsSelector = createSelector(
    (state: IRootReducer) => state.notificationsReducer.loadingNotifications,
    (loading: boolean) => loading
);

export const notificationsSelector = createSelector(
    (state: IRootReducer) => state.notificationsReducer.notifications,
    (notifications: INotification[]) => notifications
);

export const notificationsCountSelector = createSelector(
    (state: IRootReducer) => state.notificationsReducer.notifications,
    (notifications: INotification[]) => {
        return notifications.filter((notification: INotification) => {
            return !notification.isRead;
        }).length;
    }
);
